// Чистые хелперы оценки/нотации. Порт lib/eval-utils.js из v3.
import { Chess } from 'chess.js';

export interface EngineAnalysis {
  bestmove: string | null;
  ponder?: string | null;
  /** Сантипешки со стороны хода (как отдаёт UCI). */
  cp: number | null;
  mate: number | null;
  pv: string[];
  depth?: number | null;
  lines?: { move: string | null; cp: number | null; mate: number | null; pv: string[] }[];
}

export interface UciMove {
  from: string;
  to: string;
  promotion?: string;
}

export function uciToMove(uci: string | null | undefined): UciMove | null {
  if (!uci || uci.length < 4) return null;
  return { from: uci.slice(0, 2), to: uci.slice(2, 4), promotion: uci[4] };
}

export function uciToSan(fen: string, uci: string): string {
  const move = uciToMove(uci);
  if (!move) return '';
  try {
    const chess = new Chess(fen);
    const made = chess.move(move);
    return made?.san || '';
  } catch {
    return uci || '';
  }
}

export function pvToSan(fen: string, pv: string[] | null | undefined): string {
  try {
    const chess = new Chess(fen);
    const out: string[] = [];
    for (const uci of pv || []) {
      const m = uciToMove(uci);
      if (!m) break;
      const made = chess.move(m);
      if (!made) break;
      out.push(made.san);
    }
    return out.join(' ');
  } catch {
    return (pv || []).join(' ');
  }
}

/** Оценка движка приходит со стороны хода. Переводим в «со стороны белых». */
export function cpWhiteFromAnalysis(fen: string, analysis: Pick<EngineAnalysis, 'cp' | 'mate'> | null): number | null {
  if (!analysis) return null;
  const turn = fen.split(' ')[1];
  if (analysis.cp != null) return turn === 'w' ? analysis.cp : -analysis.cp;
  if (analysis.mate != null) {
    const mateForWhite = turn === 'w' ? analysis.mate : -analysis.mate;
    return mateForWhite > 0 ? 100000 : -100000;
  }
  return null;
}
